
import { ToastPanel } from '@twago/toast'

export default {
  name: 'Frameless',

  components: { ToastPanel },

  head() {
    return this.$clientI18nSeo()
  },

  computed: {
    collectedProjectData() {
      const projectData = this.$auth.$storage.getUniversal('projectData', true)

      if (projectData) {
        return projectData
      } else {
        return { id: '' }
      }
    },

    projectInformation() {
      return this.$t('talent.application.apply.header', {
        jobTitle: this.collectedProjectData.title,
        city: this.collectedProjectData.siteCity,
        hours: this.collectedProjectData.hoursPerWeek
      })
    }
  },

  watch: {
    '$nuxt.isFetching': {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$triggerLoader('PAGE', false)
        }
      }
    },

    '$route.path': {
      immediate: true,
      handler(val) {
        this.$triggerLoader('PAGE', true)
      }
    }
  },
  // mounted() {
  //   // const siteKey = this.$config.recaptchaSiteKey
  //   const siteKey = '6Lfx5I4rAAAAACiXwydjjTeW8cNYiUh-G80h2tfB'
  //   console.log('siteKey', siteKey)
  //   console.log('process.env.RECAPTCHA', this.$config.recaptchaSiteKey)
  //   if (
  //     !document.querySelector(
  //       `script[src="https://www.google.com/recaptcha/api.js?render=${siteKey}"]`
  //     )
  //   ) {
  //     const script = document.createElement('script')
  //     script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
  //     script.async = true
  //     script.defer = true
  //     script.onload = () => {
  //       console.log('reCAPTCHA script loaded')
  //     }
  //     document.head.appendChild(script)
  //   }
  // },

  methods: {
    cancelApplication() {
      // prettier-ignore
      this.$router.push(this.$link.project(this.collectedProjectData))
      this.$auth.$storage.removeUniversal('projectData')
    }
  }
}
